import { createSelector } from 'reselect'
import imageBankTypes from 'common/constants/imageBankTypes'

const generalSettings = state => state?.organizationSettings?.generalSettings
const getimageBankSettings = state => state.organizationSettings.imageBankSettings
const getimageBankType = (state, imageBankType) => imageBankType
const getDataProvider = state => state.organizationSettings.dataProviders.settings.dataProvider
export const getFollozeDataServiceSettings = state => state.organizationSettings.follozeDataService.settings
export const getPrivacySettings = state => state.organizationSettings.privacy
export const getDisplayContentItems = state => state.organizationSettings.displayContentItems
export const getFeatures = state => state.organizationSettings.features
export const getUseImageBank = createSelector(
  getimageBankSettings,
  getimageBankType,
  (imageBankSettings, imageBankType) => imageBankSettings[imageBankType] === imageBankTypes.organization
)

export const getDataProviderType = createSelector(
  getDataProvider,
  (dataProvider) => {
    return dataProvider.type
  }
)
